// import React, { useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { FiUploadCloud } from "react-icons/fi";
// import { uploadParkUserBulk } from "../redux/actions/parkUserBulkUploadActions";
// import theme from "../components/shared/theme";
// import { ClipLoader } from "react-spinners";

// const UserParkUserAddBulk = () => {
//   const dispatch = useDispatch();
//   const { loading, data, error } = useSelector(
//     (state) => state.parkUserBulkUpload
//   );

//   const [csvFile, setCsvFile] = useState(null);
//   const [previewFileName, setPreviewFileName] = useState("");
//   const [showSuccessModal, setShowSuccessModal] = useState(false);

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     setCsvFile(file);
//     setPreviewFileName(file?.name || "");
//   };

//   const handleUpload = () => {
//     if (!csvFile) {
//       alert("Please select a CSV/XLSX file.");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("file", csvFile);

//     dispatch(uploadParkUserBulk(formData)).then(() => setShowSuccessModal(true));
//   };

//   const summary = data?.data;

//   return (
//     <div
//       style={{
//         backgroundColor: theme.colors.background,
//         minHeight: "100vh",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         padding: theme.spacing.lg,
//       }}
//     >
//       <div
//         style={{
//           backgroundColor: "#fff",
//           padding: theme.spacing.xl,
//           borderRadius: theme.radius.lg,
//           boxShadow: theme.shadow.md,
//           maxWidth: 600,
//           width: "100%",
//           textAlign: "center",
//         }}
//       >
//         <h2
//           style={{
//             fontSize: theme.font.size["2xl"],
//             fontWeight: theme.font.weight.bold,
//             marginBottom: theme.spacing.md,
//             color: theme.colors.primary,
//           }}
//         >
//           Multiple Park User Upload
//         </h2>

//         {/* Template Download */}
//         <a
//           href="https://e-attendance-ebs.s3.ap-south-1.amazonaws.com/uploads/a6482cff-a04b-408d-b4c5-d8cfb2893c56"
//           download="bulk_user_park_upload_template_with_sample.xlsx"
//           style={{
//             display: "inline-block",
//             marginBottom: theme.spacing.md,
//             padding: `${theme.spacing.sm} ${theme.spacing.lg}`,
//             backgroundColor: "#0d6efd",
//             color: "white",
//             borderRadius: theme.radius.md,
//             textDecoration: "none",
//             fontWeight: "600",
//           }}
//         >
//           📥 Download Excel Template
//         </a>

//         {/* File Upload */}
//         <label
//           htmlFor="csv-upload"
//           style={{
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             border: `2px dashed ${theme.colors.gray}`,
//             borderRadius: theme.radius.md,
//             padding: theme.spacing.lg,
//             cursor: "pointer",
//             backgroundColor: "#f9f9f9",
//           }}
//         >
//           <FiUploadCloud size={48} color={theme.colors.grayDark} />
//           <p style={{ marginTop: theme.spacing.sm, color: theme.colors.grayDark }}>
//             Click to choose CSV or Excel file
//           </p>
//           <input
//             id="csv-upload"
//             type="file"
//             accept=".csv, .xlsx, .xls"
//             style={{ display: "none" }}
//             onChange={handleFileChange}
//           />
//         </label>

//         {previewFileName && (
//           <p
//             style={{
//               marginTop: theme.spacing.sm,
//               fontSize: theme.font.size.base,
//               color: theme.colors.grayDark,
//             }}
//           >
//             Selected: <strong>{previewFileName}</strong>
//           </p>
//         )}

//         {/* Error */}
//         {error && (
//           <div
//             style={{
//               marginTop: theme.spacing.md,
//               backgroundColor: "#ffebee",
//               color: "#c62828",
//               padding: theme.spacing.sm,
//               borderRadius: theme.radius.md,
//               fontWeight: "600",
//             }}
//           >
//             ❌ {error}
//           </div>
//         )}

//         {/* Upload Button */}
//         <button
//           onClick={handleUpload}
//           disabled={loading}
//           style={{
//             marginTop: theme.spacing.md,
//             padding: `${theme.spacing.sm} ${theme.spacing.lg}`,
//             backgroundColor: theme.colors.primary,
//             color: "white",
//             border: "none",
//             borderRadius: theme.radius.md,
//             fontSize: theme.font.size.base,
//             cursor: loading ? "not-allowed" : "pointer",
//             display: "inline-flex",
//             alignItems: "center",
//             justifyContent: "center",
//             gap: "8px",
//           }}
//         >
//           {loading ? <ClipLoader size={18} color="#fff" /> : "Upload"}
//         </button>

//         {/* Upload Summary */}
//         {summary && (
//           <div
//             style={{
//               marginTop: theme.spacing.lg,
//               textAlign: "left",
//               backgroundColor: "#f7f7f7",
//               borderRadius: theme.radius.md,
//               padding: theme.spacing.md,
//               fontSize: theme.font.size.base,
//             }}
//           >
//             <h4 style={{ fontWeight: theme.font.weight.semibold, marginBottom: theme.spacing.sm }}>
//               Upload Summary
//             </h4>
//             <p>
//               <strong>Total Records:</strong> {summary.total_records}
//             </p>
//             <p>
//               <strong>Inserted Records:</strong> {summary.inserted_records}
//             </p>
//             <p>
//               <strong>Skipped Records:</strong> {summary.skipped_records}
//             </p>

//             {summary.skipped_phones?.length > 0 && (
//               <div style={{ marginTop: theme.spacing.sm }}>
//                 <p><strong>Skipped Reasons:</strong></p>
//                 <ul
//                   style={{
//                     maxHeight: "150px",
//                     overflowY: "auto",
//                     paddingLeft: "20px",
//                     color: "#b00020",
//                   }}
//                 >
//                   {summary.skipped_phones.slice(0, 50).map((msg, i) => (
//                     <li key={i}>{msg}</li>
//                   ))}
//                   {summary.skipped_phones.length > 50 && (
//                     <li>...and {summary.skipped_phones.length - 50} more</li>
//                   )}
//                 </ul>
//               </div>
//             )}
//           </div>
//         )}
//       </div>

//       {/* Success Popup */}
//       {showSuccessModal && (
//         <div
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             height: "100vh",
//             width: "100vw",
//             background: "rgba(0,0,0,0.4)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 999,
//           }}
//         >
//           <div
//             style={{
//               background: "#fff",
//               padding: "30px",
//               borderRadius: "12px",
//               width: "350px",
//               textAlign: "center",
//               boxShadow: theme.shadow.md,
//             }}
//           >
//             <h3 style={{ color: "#22bb33" }}>✔ Upload Successful!</h3>
//             <p style={{ marginTop: "10px" }}>
//               Park User bulk upload completed successfully.
//             </p>
//             <button
//               onClick={() => setShowSuccessModal(false)}
//               style={{
//                 marginTop: "20px",
//                 padding: "10px 20px",
//                 backgroundColor: theme.colors.primary,
//                 color: "white",
//                 border: "none",
//                 borderRadius: theme.radius.md,
//                 cursor: "pointer",
//                 fontWeight: "600",
//               }}
//             >
//               OK
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default UserParkUserAddBulk;

// import React, { useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { FiUploadCloud, FiX, FiCheck, FiAlertCircle, FiInfo } from "react-icons/fi";
// import { uploadParkUserBulk } from "../redux/actions/parkUserBulkUploadActions";
// import theme from "../components/shared/theme";
// import { ClipLoader } from "react-spinners";

// const UserParkUserAddBulk = () => {
//   const dispatch = useDispatch();
//   const { loading, data, error } = useSelector(
//     (state) => state.parkUserBulkUpload
//   );

//   const [csvFile, setCsvFile] = useState(null);
//   const [previewFileName, setPreviewFileName] = useState("");
//   const [showSuccessModal, setShowSuccessModal] = useState(false);
//   const [showDetailsModal, setShowDetailsModal] = useState(false);
//   const [activeTab, setActiveTab] = useState("inserted");

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     setCsvFile(file);
//     setPreviewFileName(file?.name || "");
//   };

//   const handleUpload = () => {
//     if (!csvFile) {
//       alert("Please select a CSV/XLSX file.");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("file", csvFile);

//     dispatch(uploadParkUserBulk(formData)).then(() => {
//       if (data?.meta?.status) {
//         setShowSuccessModal(true);
//       }
//     });
//   };

//   const summary = data?.data;
//   const meta = data?.meta;

//   // Get status color
//   const getStatusColor = (status) => {
//     switch (status) {
//       case "success": return "#22bb33";
//       case "duplicate": return "#ff9800";
//       case "validation_failed": return "#f44336";
//       case "reference_not_found": return "#9c27b0";
//       case "error": return "#f44336";
//       default: return "#757575";
//     }
//   };

//   // Get status icon
//   const getStatusIcon = (status) => {
//     switch (status) {
//       case "success": return <FiCheck />;
//       case "duplicate": return <FiAlertCircle />;
//       case "validation_failed": return <FiX />;
//       case "reference_not_found": return <FiInfo />;
//       case "error": return <FiX />;
//       default: return <FiInfo />;
//     }
//   };

//   return (
//     <div
//       style={{
//         backgroundColor: theme.colors.background,
//         minHeight: "100vh",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         padding: theme.spacing.lg,
//       }}
//     >
//       <div
//         style={{
//           backgroundColor: "#fff",
//           padding: theme.spacing.xl,
//           borderRadius: theme.radius.lg,
//           boxShadow: theme.shadow.md,
//           maxWidth: 800,
//           width: "100%",
//           textAlign: "center",
//         }}
//       >
//         <h2
//           style={{
//             fontSize: theme.font.size["2xl"],
//             fontWeight: theme.font.weight.bold,
//             marginBottom: theme.spacing.md,
//             color: theme.colors.primary,
//           }}
//         >
//           Multiple Park User Upload
//         </h2>

//         {/* Template Download */}
//         <a
//           href="https://e-attendance-ebs.s3.ap-south-1.amazonaws.com/uploads/a6482cff-a04b-408d-b4c5-d8cfb2893c56"
//           download="bulk_user_park_upload_template_with_sample.xlsx"
//           style={{
//             display: "inline-block",
//             marginBottom: theme.spacing.md,
//             padding: `${theme.spacing.sm} ${theme.spacing.lg}`,
//             backgroundColor: "#0d6efd",
//             color: "white",
//             borderRadius: theme.radius.md,
//             textDecoration: "none",
//             fontWeight: "600",
//           }}
//         >
//           📥 Download Excel Template
//         </a>

//         {/* File Upload */}
//         <label
//           htmlFor="csv-upload"
//           style={{
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             border: `2px dashed ${theme.colors.gray}`,
//             borderRadius: theme.radius.md,
//             padding: theme.spacing.lg,
//             cursor: "pointer",
//             backgroundColor: "#f9f9f9",
//             transition: "all 0.3s ease",
//           }}
//           onMouseEnter={(e) => {
//             e.currentTarget.style.borderColor = theme.colors.primary;
//             e.currentTarget.style.backgroundColor = "#f0f7ff";
//           }}
//           onMouseLeave={(e) => {
//             e.currentTarget.style.borderColor = theme.colors.gray;
//             e.currentTarget.style.backgroundColor = "#f9f9f9";
//           }}
//         >
//           <FiUploadCloud size={48} color={theme.colors.grayDark} />
//           <p style={{ marginTop: theme.spacing.sm, color: theme.colors.grayDark }}>
//             Click to choose CSV or Excel file
//           </p>
//           <input
//             id="csv-upload"
//             type="file"
//             accept=".csv, .xlsx, .xls"
//             style={{ display: "none" }}
//             onChange={handleFileChange}
//           />
//         </label>

//         {previewFileName && (
//           <p
//             style={{
//               marginTop: theme.spacing.sm,
//               fontSize: theme.font.size.base,
//               color: theme.colors.grayDark,
//             }}
//           >
//             Selected: <strong>{previewFileName}</strong>
//           </p>
//         )}

//         {/* Global Error */}
//         {error && (
//           <div
//             style={{
//               marginTop: theme.spacing.md,
//               backgroundColor: "#ffebee",
//               color: "#c62828",
//               padding: theme.spacing.md,
//               borderRadius: theme.radius.md,
//               fontWeight: "600",
//               display: "flex",
//               alignItems: "center",
//               gap: "8px",
//             }}
//           >
//             <FiAlertCircle /> {error}
//           </div>
//         )}

//         {/* API Response Message */}
//         {meta && (
//           <div
//             style={{
//               marginTop: theme.spacing.md,
//               backgroundColor: meta.status ? "#e8f5e8" : "#ffebee",
//               color: meta.status ? "#2e7d32" : "#c62828",
//               padding: theme.spacing.md,
//               borderRadius: theme.radius.md,
//               fontWeight: "600",
//               display: "flex",
//               alignItems: "center",
//               gap: "8px",
//             }}
//           >
//             {meta.status ? <FiCheck /> : <FiAlertCircle />}
//             {meta.message}
//           </div>
//         )}

//         {/* Upload Button */}
//         <button
//           onClick={handleUpload}
//           disabled={loading || !csvFile}
//           style={{
//             marginTop: theme.spacing.md,
//             padding: `${theme.spacing.sm} ${theme.spacing.lg}`,
//             backgroundColor: csvFile ? theme.colors.primary : "#cccccc",
//             color: "white",
//             border: "none",
//             borderRadius: theme.radius.md,
//             fontSize: theme.font.size.base,
//             cursor: loading ? "not-allowed" : "pointer",
//             display: "inline-flex",
//             alignItems: "center",
//             justifyContent: "center",
//             gap: "8px",
//             transition: "all 0.3s ease",
//             opacity: loading || !csvFile ? 0.7 : 1,
//           }}
//           onMouseEnter={(e) => {
//             if (!loading && csvFile) {
//               e.currentTarget.style.backgroundColor = theme.colors.primaryDark;
//             }
//           }}
//           onMouseLeave={(e) => {
//             if (!loading && csvFile) {
//               e.currentTarget.style.backgroundColor = theme.colors.primary;
//             }
//           }}
//         >
//           {loading ? <ClipLoader size={18} color="#fff" /> : "Upload"}
//         </button>

//         {/* Upload Summary */}
//         {summary && (
//           <div
//             style={{
//               marginTop: theme.spacing.lg,
//               textAlign: "left",
//               backgroundColor: "#f7f7f7",
//               borderRadius: theme.radius.md,
//               padding: theme.spacing.md,
//               fontSize: theme.font.size.base,
//               border: `1px solid ${meta?.status ? "#4caf50" : "#f44336"}`,
//             }}
//           >
//             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: theme.spacing.sm }}>
//               <h4 style={{ fontWeight: theme.font.weight.semibold }}>
//                 Upload Summary
//               </h4>
//               <button
//                 onClick={() => setShowDetailsModal(true)}
//                 style={{
//                   padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
//                   backgroundColor: "transparent",
//                   color: theme.colors.primary,
//                   border: `1px solid ${theme.colors.primary}`,
//                   borderRadius: theme.radius.sm,
//                   cursor: "pointer",
//                   fontSize: theme.font.size.sm,
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "4px",
//                 }}
//               >
//                 <FiInfo /> View Details
//               </button>
//             </div>

//             {/* Summary Stats */}
//             <div style={{ display: "flex", gap: theme.spacing.lg, marginBottom: theme.spacing.md }}>
//               <div style={{ textAlign: "center" }}>
//                 <div style={{ fontSize: "24px", fontWeight: "bold", color: "#2196f3" }}>
//                   {summary.total_records}
//                 </div>
//                 <div style={{ fontSize: theme.font.size.sm, color: theme.colors.grayDark }}>
//                   Total
//                 </div>
//               </div>
//               <div style={{ textAlign: "center" }}>
//                 <div style={{ fontSize: "24px", fontWeight: "bold", color: "#4caf50" }}>
//                   {summary.inserted_records}
//                 </div>
//                 <div style={{ fontSize: theme.font.size.sm, color: theme.colors.grayDark }}>
//                   Inserted
//                 </div>
//               </div>
//               <div style={{ textAlign: "center" }}>
//                 <div style={{ fontSize: "24px", fontWeight: "bold", color: summary.skipped_records > 0 ? "#f44336" : "#757575" }}>
//                   {summary.skipped_records}
//                 </div>
//                 <div style={{ fontSize: theme.font.size.sm, color: theme.colors.grayDark }}>
//                   Skipped
//                 </div>
//               </div>
//             </div>

//             {/* Quick Error Summary */}
//             {summary.skipped_phones?.length > 0 && (
//               <div style={{ marginTop: theme.spacing.sm }}>
//                 <p style={{ fontWeight: "600", marginBottom: theme.spacing.xs }}>
//                   Quick Issues ({summary.skipped_records}):
//                 </p>
//                 <div
//                   style={{
//                     maxHeight: "120px",
//                     overflowY: "auto",
//                     backgroundColor: "#fff",
//                     borderRadius: theme.radius.sm,
//                     padding: theme.spacing.sm,
//                     border: "1px solid #eee",
//                   }}
//                 >
//                   {summary.skipped_phones.slice(0, 10).map((msg, i) => (
//                     <div
//                       key={i}
//                       style={{
//                         padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
//                         borderBottom: i < Math.min(9, summary.skipped_phones.length - 1) ? "1px solid #eee" : "none",
//                         fontSize: theme.font.size.sm,
//                         color: "#b00020",
//                         display: "flex",
//                         alignItems: "center",
//                         gap: "6px",
//                       }}
//                     >
//                       <FiAlertCircle size={14} />
//                       {msg}
//                     </div>
//                   ))}
//                   {summary.skipped_phones.length > 10 && (
//                     <div style={{ padding: theme.spacing.xs, color: "#757575", fontSize: theme.font.size.sm }}>
//                       ...and {summary.skipped_phones.length - 10} more issues
//                     </div>
//                   )}
//                 </div>
//               </div>
//             )}
//           </div>
//         )}
//       </div>

//       {/* Success Modal */}
//       {showSuccessModal && (
//         <div
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             height: "100vh",
//             width: "100vw",
//             background: "rgba(0,0,0,0.4)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 999,
//           }}
//         >
//           <div
//             style={{
//               background: "#fff",
//               padding: "30px",
//               borderRadius: "12px",
//               width: "350px",
//               textAlign: "center",
//               boxShadow: theme.shadow.md,
//             }}
//           >
//             <div style={{ fontSize: "48px", color: "#22bb33", marginBottom: "16px" }}>
//               <FiCheck />
//             </div>
//             <h3 style={{ color: "#22bb33", marginBottom: "8px" }}>
//               Upload Successful!
//             </h3>
//             <p style={{ marginBottom: "20px", color: "#666" }}>
//               {summary?.inserted_records} records inserted successfully.
//             </p>
//             <button
//               onClick={() => setShowSuccessModal(false)}
//               style={{
//                 padding: "10px 20px",
//                 backgroundColor: theme.colors.primary,
//                 color: "white",
//                 border: "none",
//                 borderRadius: theme.radius.md,
//                 cursor: "pointer",
//                 fontWeight: "600",
//                 width: "100%",
//               }}
//             >
//               OK
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Details Modal */}
//       {showDetailsModal && summary && (
//         <div
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             height: "100vh",
//             width: "100vw",
//             background: "rgba(0,0,0,0.5)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 1000,
//           }}
//           onClick={() => setShowDetailsModal(false)}
//         >
//           <div
//             style={{
//               background: "#fff",
//               borderRadius: "12px",
//               width: "90%",
//               maxWidth: "1000px",
//               maxHeight: "90vh",
//               overflow: "hidden",
//               display: "flex",
//               flexDirection: "column",
//               boxShadow: theme.shadow.lg,
//             }}
//             onClick={(e) => e.stopPropagation()}
//           >
//             {/* Modal Header */}
//             <div
//               style={{
//                 padding: theme.spacing.lg,
//                 borderBottom: "1px solid #eee",
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 backgroundColor: "#f8f9fa",
//               }}
//             >
//               <h3 style={{ fontWeight: "bold", color: theme.colors.primary, margin: 0 }}>
//                 Upload Details
//               </h3>
//               <button
//                 onClick={() => setShowDetailsModal(false)}
//                 style={{
//                   background: "transparent",
//                   border: "none",
//                   fontSize: "20px",
//                   cursor: "pointer",
//                   color: "#666",
//                 }}
//               >
//                 <FiX />
//               </button>
//             </div>

//             {/* Tabs */}
//             <div
//               style={{
//                 display: "flex",
//                 borderBottom: "1px solid #eee",
//                 backgroundColor: "#fff",
//               }}
//             >
//               <button
//                 onClick={() => setActiveTab("inserted")}
//                 style={{
//                   flex: 1,
//                   padding: theme.spacing.md,
//                   background: activeTab === "inserted" ? "#e3f2fd" : "transparent",
//                   border: "none",
//                   borderBottom: activeTab === "inserted" ? `2px solid ${theme.colors.primary}` : "none",
//                   cursor: "pointer",
//                   fontWeight: activeTab === "inserted" ? "600" : "400",
//                   color: activeTab === "inserted" ? theme.colors.primary : "#666",
//                 }}
//               >
//                 Inserted ({summary.inserted_records_details?.length || 0})
//               </button>
//               <button
//                 onClick={() => setActiveTab("skipped")}
//                 style={{
//                   flex: 1,
//                   padding: theme.spacing.md,
//                   background: activeTab === "skipped" ? "#ffebee" : "transparent",
//                   border: "none",
//                   borderBottom: activeTab === "skipped" ? `2px solid #f44336` : "none",
//                   cursor: "pointer",
//                   fontWeight: activeTab === "skipped" ? "600" : "400",
//                   color: activeTab === "skipped" ? "#f44336" : "#666",
//                 }}
//               >
//                 Skipped ({summary.skipped_records_details?.length || 0})
//               </button>
//             </div>

//             {/* Content */}
//             <div style={{ flex: 1, overflow: "auto", padding: theme.spacing.lg }}>
//               {activeTab === "inserted" && (
//                 <div>
//                   {summary.inserted_records_details?.length > 0 ? (
//                     <div style={{ display: "flex", flexDirection: "column", gap: theme.spacing.md }}>
//                       {summary.inserted_records_details.map((record, index) => (
//                         <div
//                           key={index}
//                           style={{
//                             border: "1px solid #e0e0e0",
//                             borderRadius: theme.radius.md,
//                             padding: theme.spacing.md,
//                             backgroundColor: "#f9f9f9",
//                           }}
//                         >
//                           <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: theme.spacing.sm }}>
//                             <div style={{ display: "flex", alignItems: "center", gap: theme.spacing.sm }}>
//                               <div
//                                 style={{
//                                   padding: "4px 8px",
//                                   backgroundColor: getStatusColor(record.status),
//                                   color: "white",
//                                   borderRadius: theme.radius.sm,
//                                   fontSize: theme.font.size.xs,
//                                   display: "flex",
//                                   alignItems: "center",
//                                   gap: "4px",
//                                 }}
//                               >
//                                 {getStatusIcon(record.status)} {record.status.toUpperCase()}
//                               </div>
//                               <span style={{ fontWeight: "600", color: "#333" }}>
//                                 Row {record.row_number}: {record.name}
//                               </span>
//                             </div>
//                             <span style={{ color: "#666", fontSize: theme.font.size.sm }}>
//                               Phone: {record.phone}
//                             </span>
//                           </div>
                          
//                           <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: theme.spacing.sm }}>
//                             <div>
//                               <strong style={{ color: "#666", fontSize: theme.font.size.sm }}>Municipality:</strong>
//                               <div>{record.municipality}</div>
//                             </div>
//                             <div>
//                               <strong style={{ color: "#666", fontSize: theme.font.size.sm }}>District:</strong>
//                               <div>{record.district}</div>
//                             </div>
//                             <div>
//                               <strong style={{ color: "#666", fontSize: theme.font.size.sm }}>Project Code:</strong>
//                               <div>{record.project_code}</div>
//                             </div>
//                             <div>
//                               <strong style={{ color: "#666", fontSize: theme.font.size.sm }}>DOJ:</strong>
//                               <div>{record.doj || "N/A"}</div>
//                             </div>
//                           </div>
                          
//                           <details style={{ marginTop: theme.spacing.sm }}>
//                             <summary style={{ cursor: "pointer", color: theme.colors.primary, fontWeight: "600" }}>
//                               View Inserted Data
//                             </summary>
//                             <pre style={{ 
//                               marginTop: theme.spacing.sm, 
//                               padding: theme.spacing.sm, 
//                               backgroundColor: "#fff", 
//                               borderRadius: theme.radius.sm,
//                               fontSize: theme.font.size.sm,
//                               overflow: "auto",
//                               maxHeight: "200px"
//                             }}>
//                               {JSON.stringify(record.inserted_data, null, 2)}
//                             </pre>
//                           </details>
//                         </div>
//                       ))}
//                     </div>
//                   ) : (
//                     <div style={{ textAlign: "center", padding: theme.spacing.xl, color: "#999" }}>
//                       No records were inserted.
//                     </div>
//                   )}
//                 </div>
//               )}

//               {activeTab === "skipped" && (
//                 <div>
//                   {summary.skipped_records_details?.length > 0 ? (
//                     <div style={{ display: "flex", flexDirection: "column", gap: theme.spacing.md }}>
//                       {summary.skipped_records_details.map((record, index) => (
//                         <div
//                           key={index}
//                           style={{
//                             border: "1px solid #ffcdd2",
//                             borderRadius: theme.radius.md,
//                             padding: theme.spacing.md,
//                             backgroundColor: "#ffebee",
//                           }}
//                         >
//                           <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: theme.spacing.sm }}>
//                             <div style={{ display: "flex", alignItems: "center", gap: theme.spacing.sm, flexWrap: "wrap" }}>
//                               <div
//                                 style={{
//                                   padding: "4px 8px",
//                                   backgroundColor: getStatusColor(record.status),
//                                   color: "white",
//                                   borderRadius: theme.radius.sm,
//                                   fontSize: theme.font.size.xs,
//                                   display: "flex",
//                                   alignItems: "center",
//                                   gap: "4px",
//                                 }}
//                               >
//                                 {getStatusIcon(record.status)} {record.status.toUpperCase()}
//                               </div>
//                               <span style={{ fontWeight: "600", color: "#333" }}>
//                                 Row {record.row_number}: {record.name}
//                               </span>
//                               <span style={{ color: "#666", fontSize: theme.font.size.sm }}>
//                                 Phone: {record.phone}
//                               </span>
//                             </div>
//                           </div>
                          
//                           <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: theme.spacing.sm, marginBottom: theme.spacing.sm }}>
//                             <div>
//                               <strong style={{ color: "#666", fontSize: theme.font.size.sm }}>Municipality:</strong>
//                               <div>{record.municipality}</div>
//                             </div>
//                             <div>
//                               <strong style={{ color: "#666", fontSize: theme.font.size.sm }}>District:</strong>
//                               <div>{record.district}</div>
//                             </div>
//                             <div>
//                               <strong style={{ color: "#666", fontSize: theme.font.size.sm }}>Project Code:</strong>
//                               <div>{record.project_code}</div>
//                             </div>
//                           </div>
                          
//                           <div>
//                             <strong style={{ color: "#c62828", fontSize: theme.font.size.sm }}>Errors:</strong>
//                             <ul style={{ marginTop: theme.spacing.xs, paddingLeft: theme.spacing.lg }}>
//                               {record.errors.map((error, errorIndex) => (
//                                 <li key={errorIndex} style={{ color: "#c62828", marginBottom: theme.spacing.xs }}>
//                                   {error}
//                                 </li>
//                               ))}
//                             </ul>
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   ) : (
//                     <div style={{ textAlign: "center", padding: theme.spacing.xl, color: "#999" }}>
//                       No records were skipped.
//                     </div>
//                   )}
//                 </div>
//               )}
//             </div>

//             {/* Modal Footer */}
//             <div
//               style={{
//                 padding: theme.spacing.md,
//                 borderTop: "1px solid #eee",
//                 textAlign: "right",
//                 backgroundColor: "#f8f9fa",
//               }}
//             >
//               <button
//                 onClick={() => setShowDetailsModal(false)}
//                 style={{
//                   padding: `${theme.spacing.sm} ${theme.spacing.lg}`,
//                   backgroundColor: theme.colors.primary,
//                   color: "white",
//                   border: "none",
//                   borderRadius: theme.radius.md,
//                   cursor: "pointer",
//                   fontWeight: "600",
//                 }}
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default UserParkUserAddBulk;


import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FiUploadCloud, FiX, FiCheck, FiAlertCircle, FiInfo, FiDownload } from "react-icons/fi";
import { uploadParkUserBulk } from "../redux/actions/parkUserBulkUploadActions";
import theme from "../components/shared/theme";
import { ClipLoader } from "react-spinners";
import * as XLSX from "xlsx";

const UserParkUserAddBulk = () => {
  const dispatch = useDispatch();
  const { loading, data, error } = useSelector(
    (state) => state.parkUserBulkUpload
  );

  const [csvFile, setCsvFile] = useState(null);
  const [previewFileName, setPreviewFileName] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [activeTab, setActiveTab] = useState("inserted");

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setCsvFile(file);
    setPreviewFileName(file?.name || "");
  };

  const handleUpload = () => {
    if (!csvFile) {
      alert("Please select a CSV/XLSX file.");
      return;
    }

    const formData = new FormData();
    formData.append("file", csvFile);

    dispatch(uploadParkUserBulk(formData)).then(() => {
      if (data?.meta?.status) {
        setShowSuccessModal(true);
      }
    });
  };

  const summary = data?.data;
  const meta = data?.meta;

  // Download CSV function
  const downloadCSV = (data, filename) => {
    const csvContent = convertToCSV(data);
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Download Excel function
  const downloadExcel = (data, filename, sheetName) => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
    XLSX.writeFile(wb, filename);
  };

  // Convert JSON to CSV
  const convertToCSV = (data) => {
    if (!data || data.length === 0) return '';
    
    const headers = Object.keys(data[0]);
    const csvRows = [];
    
    // Add headers
    csvRows.push(headers.join(','));
    
    // Add rows
    for (const row of data) {
      const values = headers.map(header => {
        const value = row[header];
        // Handle null/undefined and escape quotes
        if (value === null || value === undefined) return '';
        const escaped = String(value).replace(/"/g, '""');
        return `"${escaped}"`;
      });
      csvRows.push(values.join(','));
    }
    
    return csvRows.join('\n');
  };

  // Prepare inserted data for download
  const prepareInsertedData = () => {
    if (!summary?.inserted_records_details) return [];
    
    return summary.inserted_records_details.map(record => ({
      'Row Number': record.row_number,
      'Name': record.name,
      'Phone': record.phone,
      'Municipality': record.municipality,
      'District': record.district,
      'Project Code': record.project_code,
      'Designation': record.designation || '',
      'Date of Joining': record.doj || '',
      'Status': record.status,
      'User ID': record.user_id || '',
      'District ID': record.inserted_data?.district_id || '',
      'Municipality ID': record.inserted_data?.municipality_id || '',
      'Admin ID': record.inserted_data?.admin_id || '',
      'Park ID': record.inserted_data?.park_id || '',
      'Role ID': record.inserted_data?.role_id || ''
    }));
  };

  // Prepare skipped data for download
  const prepareSkippedData = () => {
    if (!summary?.skipped_records_details) return [];
    
    return summary.skipped_records_details.map(record => ({
      'Row Number': record.row_number,
      'Name': record.name,
      'Phone': record.phone,
      'Municipality': record.municipality,
      'District': record.district,
      'Project Code': record.project_code || '',
      'Designation': record.designation || '',
      'Date of Joining': record.doj || '',
      'Status': record.status,
      'Error Messages': record.errors?.join('; ') || '',
      'Original Row': record.row_number
    }));
  };

  // Download success report
  const downloadSuccessReport = (format = 'excel') => {
    const data = prepareInsertedData();
    if (data.length === 0) {
      alert('No successful records to download.');
      return;
    }
    
    const timestamp = new Date().toISOString().replace(/[:.]/g, '-').split('T')[0];
    const filename = `successful_records_${timestamp}`;
    
    if (format === 'excel') {
      downloadExcel(data, `${filename}.xlsx`, 'Successful Records');
    } else {
      downloadCSV(data, `${filename}.csv`);
    }
  };

  // Download failure report
  const downloadFailureReport = (format = 'excel') => {
    const data = prepareSkippedData();
    if (data.length === 0) {
      alert('No failed records to download.');
      return;
    }
    
    const timestamp = new Date().toISOString().replace(/[:.]/g, '-').split('T')[0];
    const filename = `failed_records_${timestamp}`;
    
    if (format === 'excel') {
      downloadExcel(data, `${filename}.xlsx`, 'Failed Records');
    } else {
      downloadCSV(data, `${filename}.csv`);
    }
  };

  // Download full report (both success and failure)
  const downloadFullReport = (format = 'excel') => {
    const successData = prepareInsertedData();
    const failureData = prepareSkippedData();
    
    if (successData.length === 0 && failureData.length === 0) {
      alert('No records to download.');
      return;
    }
    
    const timestamp = new Date().toISOString().replace(/[:.]/g, '-').split('T')[0];
    const filename = `full_upload_report_${timestamp}`;
    
    if (format === 'excel') {
      // Create workbook with multiple sheets
      const wb = XLSX.utils.book_new();
      
      if (successData.length > 0) {
        const ws1 = XLSX.utils.json_to_sheet(successData);
        XLSX.utils.book_append_sheet(wb, ws1, 'Successful Records');
      }
      
      if (failureData.length > 0) {
        const ws2 = XLSX.utils.json_to_sheet(failureData);
        XLSX.utils.book_append_sheet(wb, ws2, 'Failed Records');
      }
      
      // Summary sheet
      const summaryData = [{
        'Total Records': summary?.total_records || 0,
        'Successfully Inserted': summary?.inserted_records || 0,
        'Skipped/Failed': summary?.skipped_records || 0,
        'Success Rate': summary?.total_records ? `${((summary.inserted_records / summary.total_records) * 100).toFixed(2)}%` : '0%',
        'Upload Status': meta?.status ? 'Success' : 'Partial/Failure',
        'Message': meta?.message || ''
      }];
      const ws3 = XLSX.utils.json_to_sheet(summaryData);
      XLSX.utils.book_append_sheet(wb, ws3, 'Summary');
      
      XLSX.writeFile(wb, `${filename}.xlsx`);
    } else {
      // For CSV, combine with status indicator
      const combinedData = [
        ...successData.map(item => ({ ...item, 'Record Type': 'SUCCESS' })),
        ...failureData.map(item => ({ ...item, 'Record Type': 'FAILED' }))
      ];
      downloadCSV(combinedData, `${filename}.csv`);
    }
  };

  // Get status color
  const getStatusColor = (status) => {
    switch (status) {
      case "success": return "#22bb33";
      case "duplicate": return "#ff9800";
      case "validation_failed": return "#f44336";
      case "reference_not_found": return "#9c27b0";
      case "error": return "#f44336";
      default: return "#757575";
    }
  };

  // Get status icon
  const getStatusIcon = (status) => {
    switch (status) {
      case "success": return <FiCheck />;
      case "duplicate": return <FiAlertCircle />;
      case "validation_failed": return <FiX />;
      case "reference_not_found": return <FiInfo />;
      case "error": return <FiX />;
      default: return <FiInfo />;
    }
  };

  return (
    <div
      style={{
        backgroundColor: theme.colors.background,
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: theme.spacing.lg,
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: theme.spacing.xl,
          borderRadius: theme.radius.lg,
          boxShadow: theme.shadow.md,
          maxWidth: 800,
          width: "100%",
          textAlign: "center",
        }}
      >
        <h2
          style={{
            fontSize: theme.font.size["2xl"],
            fontWeight: theme.font.weight.bold,
            marginBottom: theme.spacing.md,
            color: theme.colors.primary,
          }}
        >
          Multiple Park User Upload
        </h2>

        {/* Template Download */}
        <a
          href="https://e-attendance-ebs.s3.ap-south-1.amazonaws.com/uploads/8a0383f5-2ca9-4275-9726-4bdc0fc03b0f"
          download="bulk_user_park_upload_template_with_sample.xlsx"
          style={{
            display: "inline-block",
            marginBottom: theme.spacing.md,
            padding: `${theme.spacing.sm} ${theme.spacing.lg}`,
            backgroundColor: "#0d6efd",
            color: "white",
            borderRadius: theme.radius.md,
            textDecoration: "none",
            fontWeight: "600",
          }}
        >
          📥 Download Excel Template
        </a>

        {/* File Upload */}
        <label
          htmlFor="csv-upload"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            border: `2px dashed ${theme.colors.gray}`,
            borderRadius: theme.radius.md,
            padding: theme.spacing.lg,
            cursor: "pointer",
            backgroundColor: "#f9f9f9",
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = theme.colors.primary;
            e.currentTarget.style.backgroundColor = "#f0f7ff";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = theme.colors.gray;
            e.currentTarget.style.backgroundColor = "#f9f9f9";
          }}
        >
          <FiUploadCloud size={48} color={theme.colors.grayDark} />
          <p style={{ marginTop: theme.spacing.sm, color: theme.colors.grayDark }}>
            Click to choose CSV or Excel file
          </p>
          <input
            id="csv-upload"
            type="file"
            accept=".csv, .xlsx, .xls"
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
        </label>

        {previewFileName && (
          <p
            style={{
              marginTop: theme.spacing.sm,
              fontSize: theme.font.size.base,
              color: theme.colors.grayDark,
            }}
          >
            Selected: <strong>{previewFileName}</strong>
          </p>
        )}

        {/* Global Error */}
        {error && (
          <div
            style={{
              marginTop: theme.spacing.md,
              backgroundColor: "#ffebee",
              color: "#c62828",
              padding: theme.spacing.md,
              borderRadius: theme.radius.md,
              fontWeight: "600",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <FiAlertCircle /> {error}
          </div>
        )}

        {/* API Response Message */}
        {meta && (
          <div
            style={{
              marginTop: theme.spacing.md,
              backgroundColor: meta.status ? "#e8f5e8" : "#ffebee",
              color: meta.status ? "#2e7d32" : "#c62828",
              padding: theme.spacing.md,
              borderRadius: theme.radius.md,
              fontWeight: "600",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            {meta.status ? <FiCheck /> : <FiAlertCircle />}
            {meta.message}
          </div>
        )}

        {/* Upload Button */}
        <button
          onClick={handleUpload}
          disabled={loading || !csvFile}
          style={{
            marginTop: theme.spacing.md,
            padding: `${theme.spacing.sm} ${theme.spacing.lg}`,
            backgroundColor: csvFile ? theme.colors.primary : "#cccccc",
            color: "white",
            border: "none",
            borderRadius: theme.radius.md,
            fontSize: theme.font.size.base,
            cursor: loading ? "not-allowed" : "pointer",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
            transition: "all 0.3s ease",
            opacity: loading || !csvFile ? 0.7 : 1,
          }}
          onMouseEnter={(e) => {
            if (!loading && csvFile) {
              e.currentTarget.style.backgroundColor = theme.colors.primaryDark;
            }
          }}
          onMouseLeave={(e) => {
            if (!loading && csvFile) {
              e.currentTarget.style.backgroundColor = theme.colors.primary;
            }
          }}
        >
          {loading ? <ClipLoader size={18} color="#fff" /> : "Upload"}
        </button>

        {/* Download Reports Section */}
        {summary && (
          <div
            style={{
              marginTop: theme.spacing.lg,
              textAlign: "left",
              backgroundColor: "#f0f7ff",
              borderRadius: theme.radius.md,
              padding: theme.spacing.md,
              fontSize: theme.font.size.base,
              border: `1px solid ${theme.colors.primaryLight}`,
            }}
          >
            <h4 style={{ fontWeight: theme.font.weight.semibold, marginBottom: theme.spacing.sm, color: theme.colors.primary }}>
              Download Reports
            </h4>
            <div style={{ display: "flex", flexWrap: "wrap", gap: theme.spacing.sm }}>
              <button
                onClick={() => downloadFullReport('excel')}
                style={{
                  padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
                  backgroundColor: theme.colors.primary,
                  color: "white",
                  border: "none",
                  borderRadius: theme.radius.sm,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  fontSize: theme.font.size.sm,
                }}
              >
                <FiDownload /> Full Report (Excel)
              </button>
              
              {summary.inserted_records > 0 && (
                <button
                  onClick={() => downloadSuccessReport('excel')}
                  style={{
                    padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
                    backgroundColor: "#4caf50",
                    color: "white",
                    border: "none",
                    borderRadius: theme.radius.sm,
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    fontSize: theme.font.size.sm,
                  }}
                >
                  <FiDownload /> Success ({summary.inserted_records})
                </button>
              )}
              
              {summary.skipped_records > 0 && (
                <button
                  onClick={() => downloadFailureReport('excel')}
                  style={{
                    padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
                    backgroundColor: "#f44336",
                    color: "white",
                    border: "none",
                    borderRadius: theme.radius.sm,
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    fontSize: theme.font.size.sm,
                  }}
                >
                  <FiDownload /> Failed ({summary.skipped_records})
                </button>
              )}
              
              <button
                onClick={() => downloadFullReport('csv')}
                style={{
                  padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
                  backgroundColor: "#757575",
                  color: "white",
                  border: "none",
                  borderRadius: theme.radius.sm,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  fontSize: theme.font.size.sm,
                }}
              >
                <FiDownload /> CSV Format
              </button>
            </div>
          </div>
        )}

        {/* Upload Summary */}
        {summary && (
          <div
            style={{
              marginTop: theme.spacing.lg,
              textAlign: "left",
              backgroundColor: "#f7f7f7",
              borderRadius: theme.radius.md,
              padding: theme.spacing.md,
              fontSize: theme.font.size.base,
              border: `1px solid ${meta?.status ? "#4caf50" : "#f44336"}`,
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: theme.spacing.sm }}>
              <h4 style={{ fontWeight: theme.font.weight.semibold }}>
                Upload Summary
              </h4>
              <button
                onClick={() => setShowDetailsModal(true)}
                style={{
                  padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
                  backgroundColor: "transparent",
                  color: theme.colors.primary,
                  border: `1px solid ${theme.colors.primary}`,
                  borderRadius: theme.radius.sm,
                  cursor: "pointer",
                  fontSize: theme.font.size.sm,
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <FiInfo /> View Details
              </button>
            </div>

            {/* Summary Stats */}
            <div style={{ display: "flex", gap: theme.spacing.lg, marginBottom: theme.spacing.md }}>
              <div style={{ textAlign: "center" }}>
                <div style={{ fontSize: "24px", fontWeight: "bold", color: "#2196f3" }}>
                  {summary.total_records}
                </div>
                <div style={{ fontSize: theme.font.size.sm, color: theme.colors.grayDark }}>
                  Total
                </div>
              </div>
              <div style={{ textAlign: "center" }}>
                <div style={{ fontSize: "24px", fontWeight: "bold", color: "#4caf50" }}>
                  {summary.inserted_records}
                </div>
                <div style={{ fontSize: theme.font.size.sm, color: theme.colors.grayDark }}>
                  Inserted
                </div>
              </div>
              <div style={{ textAlign: "center" }}>
                <div style={{ fontSize: "24px", fontWeight: "bold", color: summary.skipped_records > 0 ? "#f44336" : "#757575" }}>
                  {summary.skipped_records}
                </div>
                <div style={{ fontSize: theme.font.size.sm, color: theme.colors.grayDark }}>
                  Skipped
                </div>
              </div>
            </div>

            {/* Quick Error Summary */}
            {summary.skipped_phones?.length > 0 && (
              <div style={{ marginTop: theme.spacing.sm }}>
                <p style={{ fontWeight: "600", marginBottom: theme.spacing.xs }}>
                  Quick Issues ({summary.skipped_records}):
                </p>
                <div
                  style={{
                    maxHeight: "120px",
                    overflowY: "auto",
                    backgroundColor: "#fff",
                    borderRadius: theme.radius.sm,
                    padding: theme.spacing.sm,
                    border: "1px solid #eee",
                  }}
                >
                  {summary.skipped_phones.slice(0, 10).map((msg, i) => (
                    <div
                      key={i}
                      style={{
                        padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
                        borderBottom: i < Math.min(9, summary.skipped_phones.length - 1) ? "1px solid #eee" : "none",
                        fontSize: theme.font.size.sm,
                        color: "#b00020",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      <FiAlertCircle size={14} />
                      {msg}
                    </div>
                  ))}
                  {summary.skipped_phones.length > 10 && (
                    <div style={{ padding: theme.spacing.xs, color: "#757575", fontSize: theme.font.size.sm }}>
                      ...and {summary.skipped_phones.length - 10} more issues
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Success Modal */}
      {showSuccessModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: "100vw",
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 999,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "30px",
              borderRadius: "12px",
              width: "350px",
              textAlign: "center",
              boxShadow: theme.shadow.md,
            }}
          >
            <div style={{ fontSize: "48px", color: "#22bb33", marginBottom: "16px" }}>
              <FiCheck />
            </div>
            <h3 style={{ color: "#22bb33", marginBottom: "8px" }}>
              Upload Successful!
            </h3>
            <p style={{ marginBottom: "20px", color: "#666" }}>
              {summary?.inserted_records} records inserted successfully.
            </p>
            <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
              <button
                onClick={() => {
                  setShowSuccessModal(false);
                  downloadSuccessReport('excel');
                }}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#4caf50",
                  color: "white",
                  border: "none",
                  borderRadius: theme.radius.md,
                  cursor: "pointer",
                  fontWeight: "600",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                <FiDownload /> Download Success Report
              </button>
            </div>
            <button
              onClick={() => setShowSuccessModal(false)}
              style={{
                marginTop: "15px",
                padding: "8px 20px",
                backgroundColor: theme.colors.primary,
                color: "white",
                border: "none",
                borderRadius: theme.radius.md,
                cursor: "pointer",
                fontWeight: "600",
                width: "100%",
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}

      {/* Details Modal (same as before but with download buttons in header) */}
      {showDetailsModal && summary && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: "100vw",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
          onClick={() => setShowDetailsModal(false)}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "12px",
              width: "90%",
              maxWidth: "1000px",
              maxHeight: "90vh",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              boxShadow: theme.shadow.lg,
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header with download buttons */}
            <div
              style={{
                padding: theme.spacing.lg,
                borderBottom: "1px solid #eee",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#f8f9fa",
                flexWrap: "wrap",
                gap: theme.spacing.sm,
              }}
            >
              <h3 style={{ fontWeight: "bold", color: theme.colors.primary, margin: 0 }}>
                Upload Details
              </h3>
              <div style={{ display: "flex", gap: theme.spacing.sm, alignItems: "center" }}>
                <div style={{ display: "flex", gap: "4px" }}>
                  <button
                    onClick={() => downloadFullReport('excel')}
                    style={{
                      padding: "6px 12px",
                      backgroundColor: theme.colors.primary,
                      color: "white",
                      border: "none",
                      borderRadius: "4px",
                      cursor: "pointer",
                      fontSize: "12px",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                    title="Download Full Report"
                  >
                    <FiDownload size={14} />
                  </button>
                  {summary.inserted_records > 0 && (
                    <button
                      onClick={() => downloadSuccessReport('excel')}
                      style={{
                        padding: "6px 12px",
                        backgroundColor: "#4caf50",
                        color: "white",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                        fontSize: "12px",
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                      title="Download Success Report"
                    >
                      <FiDownload size={14} />
                    </button>
                  )}
                  {summary.skipped_records > 0 && (
                    <button
                      onClick={() => downloadFailureReport('excel')}
                      style={{
                        padding: "6px 12px",
                        backgroundColor: "#f44336",
                        color: "white",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                        fontSize: "12px",
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                      title="Download Failure Report"
                    >
                      <FiDownload size={14} />
                    </button>
                  )}
                </div>
                <button
                  onClick={() => setShowDetailsModal(false)}
                  style={{
                    background: "transparent",
                    border: "none",
                    fontSize: "20px",
                    cursor: "pointer",
                    color: "#666",
                  }}
                >
                  <FiX />
                </button>
              </div>
            </div>

           {/* Details Modal */}
{showDetailsModal && summary && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      height: "100vh",
      width: "100vw",
      background: "rgba(0,0,0,0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    }}
    onClick={() => setShowDetailsModal(false)}
  >
    <div
      style={{
        background: "#fff",
        borderRadius: "12px",
        width: "90%",
        maxWidth: "1000px",
        maxHeight: "90vh",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        boxShadow: theme.shadow.lg,
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {/* Modal Header with download buttons */}
      <div
        style={{
          padding: theme.spacing.lg,
          borderBottom: "1px solid #eee",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#f8f9fa",
          flexWrap: "wrap",
          gap: theme.spacing.sm,
        }}
      >
        <h3 style={{ fontWeight: "bold", color: theme.colors.primary, margin: 0 }}>
          Upload Details
        </h3>
        <div style={{ display: "flex", gap: theme.spacing.sm, alignItems: "center" }}>
          <div style={{ display: "flex", gap: "4px" }}>
            <button
              onClick={() => downloadFullReport('excel')}
              style={{
                padding: "6px 12px",
                backgroundColor: theme.colors.primary,
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "12px",
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
              title="Download Full Report"
            >
              <FiDownload size={14} /> Full
            </button>
            {summary.inserted_records > 0 && (
              <button
                onClick={() => downloadSuccessReport('excel')}
                style={{
                  padding: "6px 12px",
                  backgroundColor: "#4caf50",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "12px",
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
                title="Download Success Report"
              >
                <FiDownload size={14} /> Success
              </button>
            )}
            {summary.skipped_records > 0 && (
              <button
                onClick={() => downloadFailureReport('excel')}
                style={{
                  padding: "6px 12px",
                  backgroundColor: "#f44336",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "12px",
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
                title="Download Failure Report"
              >
                <FiDownload size={14} /> Failed
              </button>
            )}
            <button
              onClick={() => downloadFullReport('csv')}
              style={{
                padding: "6px 12px",
                backgroundColor: "#757575",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "12px",
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
              title="Download CSV"
            >
              <FiDownload size={14} /> CSV
            </button>
          </div>
          <button
            onClick={() => setShowDetailsModal(false)}
            style={{
              background: "transparent",
              border: "none",
              fontSize: "20px",
              cursor: "pointer",
              color: "#666",
            }}
          >
            <FiX />
          </button>
        </div>
      </div>

      {/* Tabs */}
      <div
        style={{
          display: "flex",
          borderBottom: "1px solid #eee",
          backgroundColor: "#fff",
        }}
      >
        <button
          onClick={() => setActiveTab("inserted")}
          style={{
            flex: 1,
            padding: theme.spacing.md,
            background: activeTab === "inserted" ? "#e3f2fd" : "transparent",
            border: "none",
            borderBottom: activeTab === "inserted" ? `2px solid ${theme.colors.primary}` : "none",
            cursor: "pointer",
            fontWeight: activeTab === "inserted" ? "600" : "400",
            color: activeTab === "inserted" ? theme.colors.primary : "#666",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
          }}
        >
          <FiCheck />
          Inserted ({summary.inserted_records_details?.length || 0})
        </button>
        <button
          onClick={() => setActiveTab("skipped")}
          style={{
            flex: 1,
            padding: theme.spacing.md,
            background: activeTab === "skipped" ? "#ffebee" : "transparent",
            border: "none",
            borderBottom: activeTab === "skipped" ? `2px solid #f44336` : "none",
            cursor: "pointer",
            fontWeight: activeTab === "skipped" ? "600" : "400",
            color: activeTab === "skipped" ? "#f44336" : "#666",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
          }}
        >
          <FiAlertCircle />
          Skipped ({summary.skipped_records_details?.length || 0})
        </button>
      </div>

      {/* Content Area */}
      <div style={{ flex: 1, overflow: "auto", padding: theme.spacing.lg }}>
        {activeTab === "inserted" && (
          <div>
            {summary.inserted_records_details?.length > 0 ? (
              <div>
                {/* Summary Bar */}
                <div
                  style={{
                    backgroundColor: "#e8f5e8",
                    padding: theme.spacing.md,
                    borderRadius: theme.radius.md,
                    marginBottom: theme.spacing.lg,
                    border: "1px solid #4caf50",
                  }}
                >
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: theme.spacing.md }}>
                      <div style={{ fontSize: "24px", fontWeight: "bold", color: "#2e7d32" }}>
                        {summary.inserted_records}
                      </div>
                      <div>
                        <div style={{ fontWeight: "600", color: "#2e7d32" }}>Successfully Inserted</div>
                        <div style={{ fontSize: theme.font.size.sm, color: "#666" }}>
                          {summary.total_records - summary.skipped_records} of {summary.total_records} records
                        </div>
                      </div>
                    </div>
                    <button
                      onClick={() => downloadSuccessReport('excel')}
                      style={{
                        padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
                        backgroundColor: "#4caf50",
                        color: "white",
                        border: "none",
                        borderRadius: theme.radius.sm,
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        fontSize: theme.font.size.sm,
                      }}
                    >
                      <FiDownload /> Download Excel
                    </button>
                  </div>
                </div>

                {/* Records List */}
                <div style={{ display: "flex", flexDirection: "column", gap: theme.spacing.md }}>
                  {summary.inserted_records_details.map((record, index) => (
                    <div
                      key={index}
                      style={{
                        border: "1px solid #e0e0e0",
                        borderRadius: theme.radius.md,
                        padding: theme.spacing.md,
                        backgroundColor: "#f9f9f9",
                        transition: "all 0.2s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
                        e.currentTarget.style.borderColor = "#4caf50";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.boxShadow = "none";
                        e.currentTarget.style.borderColor = "#e0e0e0";
                      }}
                    >
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: theme.spacing.sm }}>
                        <div style={{ display: "flex", alignItems: "center", gap: theme.spacing.sm }}>
                          <div
                            style={{
                              padding: "4px 8px",
                              backgroundColor: getStatusColor(record.status),
                              color: "white",
                              borderRadius: theme.radius.sm,
                              fontSize: theme.font.size.xs,
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            {getStatusIcon(record.status)} {record.status.toUpperCase()}
                          </div>
                          <span style={{ fontWeight: "600", color: "#333" }}>
                            Row {record.row_number}: {record.name}
                          </span>
                        </div>
                        <span style={{ color: "#666", fontSize: theme.font.size.sm }}>
                          Phone: {record.phone}
                        </span>
                      </div>
                      
                      <div style={{ 
                        display: "grid", 
                        gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", 
                        gap: theme.spacing.sm,
                        marginBottom: theme.spacing.sm 
                      }}>
                        <div>
                          <strong style={{ color: "#666", fontSize: theme.font.size.sm }}>Municipality:</strong>
                          <div>{record.municipality}</div>
                        </div>
                        <div>
                          <strong style={{ color: "#666", fontSize: theme.font.size.sm }}>District:</strong>
                          <div>{record.district}</div>
                        </div>
                        <div>
                          <strong style={{ color: "#666", fontSize: theme.font.size.sm }}>Project Code:</strong>
                          <div>{record.project_code}</div>
                        </div>
                        <div>
                          <strong style={{ color: "#666", fontSize: theme.font.size.sm }}>Designation:</strong>
                          <div>{record.designation || "N/A"}</div>
                        </div>
                        <div>
                          <strong style={{ color: "#666", fontSize: theme.font.size.sm }}>DOJ:</strong>
                          <div>{record.doj || "N/A"}</div>
                        </div>
                        {record.user_id && (
                          <div>
                            <strong style={{ color: "#666", fontSize: theme.font.size.sm }}>User ID:</strong>
                            <div>{record.user_id}</div>
                          </div>
                        )}
                      </div>
                      
                      <details style={{ marginTop: theme.spacing.sm }}>
                        <summary style={{ 
                          cursor: "pointer", 
                          color: theme.colors.primary, 
                          fontWeight: "600",
                          padding: theme.spacing.xs,
                          borderRadius: theme.radius.sm,
                          backgroundColor: "#f0f7ff",
                        }}>
                          View Detailed Inserted Data
                        </summary>
                        <div style={{ 
                          marginTop: theme.spacing.sm, 
                          padding: theme.spacing.sm, 
                          backgroundColor: "#fff", 
                          borderRadius: theme.radius.sm,
                          border: "1px solid #e0e0e0",
                        }}>
                          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))", gap: theme.spacing.sm }}>
                            {record.inserted_data && Object.entries(record.inserted_data).map(([key, value]) => (
                              <div key={key}>
                                <strong style={{ color: "#666", fontSize: theme.font.size.sm }}>
                                  {key.replace(/_/g, ' ').toUpperCase()}:
                                </strong>
                                <div style={{ 
                                  padding: "2px 4px", 
                                  backgroundColor: "#f5f5f5", 
                                  borderRadius: "3px",
                                  marginTop: "2px",
                                  fontSize: theme.font.size.sm
                                }}>
                                  {value !== null && value !== undefined ? value.toString() : "N/A"}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </details>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div style={{ 
                textAlign: "center", 
                padding: theme.spacing.xl, 
                color: "#999",
                backgroundColor: "#f9f9f9",
                borderRadius: theme.radius.md,
                border: "1px dashed #ddd"
              }}>
                <FiInfo size={48} style={{ marginBottom: theme.spacing.md, color: "#ccc" }} />
                <div style={{ fontSize: theme.font.size.lg, marginBottom: theme.spacing.sm }}>
                  No records were inserted
                </div>
                <div style={{ fontSize: theme.font.size.sm }}>
                  All records were either skipped or failed validation
                </div>
              </div>
            )}
          </div>
        )}

        {activeTab === "skipped" && (
          <div>
            {summary.skipped_records_details?.length > 0 ? (
              <div>
                {/* Summary Bar */}
                <div
                  style={{
                    backgroundColor: "#ffebee",
                    padding: theme.spacing.md,
                    borderRadius: theme.radius.md,
                    marginBottom: theme.spacing.lg,
                    border: "1px solid #f44336",
                  }}
                >
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: theme.spacing.md }}>
                      <div style={{ fontSize: "24px", fontWeight: "bold", color: "#c62828" }}>
                        {summary.skipped_records}
                      </div>
                      <div>
                        <div style={{ fontWeight: "600", color: "#c62828" }}>Skipped/Failed Records</div>
                        <div style={{ fontSize: theme.font.size.sm, color: "#666" }}>
                          {summary.skipped_records} of {summary.total_records} records need attention
                        </div>
                      </div>
                    </div>
                    <button
                      onClick={() => downloadFailureReport('excel')}
                      style={{
                        padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
                        backgroundColor: "#f44336",
                        color: "white",
                        border: "none",
                        borderRadius: theme.radius.sm,
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        fontSize: theme.font.size.sm,
                      }}
                    >
                      <FiDownload /> Download Excel
                    </button>
                  </div>
                </div>

                {/* Status Summary */}
                <div style={{ marginBottom: theme.spacing.lg }}>
                  <div style={{ 
                    display: "flex", 
                    flexWrap: "wrap", 
                    gap: theme.spacing.sm,
                    marginBottom: theme.spacing.md 
                  }}>
                    {["duplicate", "validation_failed", "reference_not_found", "error"].map(statusType => {
                      const count = summary.skipped_records_details?.filter(r => r.status === statusType).length || 0;
                      if (count === 0) return null;
                      
                      return (
                        <div
                          key={statusType}
                          style={{
                            padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
                            backgroundColor: getStatusColor(statusType),
                            color: "white",
                            borderRadius: theme.radius.sm,
                            fontSize: theme.font.size.sm,
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          {getStatusIcon(statusType)} {statusType.replace(/_/g, ' ').toUpperCase()}: {count}
                        </div>
                      );
                    })}
                  </div>
                </div>

                {/* Records List */}
                <div style={{ display: "flex", flexDirection: "column", gap: theme.spacing.md }}>
                  {summary.skipped_records_details.map((record, index) => (
                    <div
                      key={index}
                      style={{
                        border: "1px solid #ffcdd2",
                        borderRadius: theme.radius.md,
                        padding: theme.spacing.md,
                        backgroundColor: "#ffebee",
                        transition: "all 0.2s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.boxShadow = "0 2px 8px rgba(244, 67, 54, 0.2)";
                        e.currentTarget.style.borderColor = "#f44336";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.boxShadow = "none";
                        e.currentTarget.style.borderColor = "#ffcdd2";
                      }}
                    >
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: theme.spacing.sm }}>
                        <div style={{ display: "flex", alignItems: "center", gap: theme.spacing.sm, flexWrap: "wrap" }}>
                          <div
                            style={{
                              padding: "4px 8px",
                              backgroundColor: getStatusColor(record.status),
                              color: "white",
                              borderRadius: theme.radius.sm,
                              fontSize: theme.font.size.xs,
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            {getStatusIcon(record.status)} {record.status.toUpperCase()}
                          </div>
                          <span style={{ fontWeight: "600", color: "#333" }}>
                            Row {record.row_number}: {record.name}
                          </span>
                        </div>
                        <span style={{ color: "#666", fontSize: theme.font.size.sm }}>
                          Phone: {record.phone}
                        </span>
                      </div>
                      
                      <div style={{ 
                        display: "grid", 
                        gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", 
                        gap: theme.spacing.sm, 
                        marginBottom: theme.spacing.sm 
                      }}>
                        <div>
                          <strong style={{ color: "#666", fontSize: theme.font.size.sm }}>Municipality:</strong>
                          <div>{record.municipality}</div>
                        </div>
                        <div>
                          <strong style={{ color: "#666", fontSize: theme.font.size.sm }}>District:</strong>
                          <div>{record.district}</div>
                        </div>
                        <div>
                          <strong style={{ color: "#666", fontSize: theme.font.size.sm }}>Project Code:</strong>
                          <div>{record.project_code || "N/A"}</div>
                        </div>
                        <div>
                          <strong style={{ color: "#666", fontSize: theme.font.size.sm }}>Designation:</strong>
                          <div>{record.designation || "N/A"}</div>
                        </div>
                        <div>
                          <strong style={{ color: "#666", fontSize: theme.font.size.sm }}>DOJ:</strong>
                          <div>{record.doj || "N/A"}</div>
                        </div>
                      </div>
                      
                      <div>
                        <strong style={{ color: "#c62828", fontSize: theme.font.size.sm, display: "flex", alignItems: "center", gap: "4px" }}>
                          <FiAlertCircle /> Errors ({record.errors?.length || 0}):
                        </strong>
                        <div style={{ 
                          marginTop: theme.spacing.xs, 
                          padding: theme.spacing.sm, 
                          backgroundColor: "#fff", 
                          borderRadius: theme.radius.sm,
                          border: "1px solid #ffcdd2",
                        }}>
                          {record.errors?.map((error, errorIndex) => (
                            <div 
                              key={errorIndex}
                              style={{ 
                                color: "#c62828", 
                                padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
                                borderBottom: errorIndex < (record.errors.length - 1) ? "1px solid #ffebee" : "none",
                                display: "flex",
                                alignItems: "flex-start",
                                gap: "8px",
                              }}
                            >
                              <div style={{ color: "#f44336", flexShrink: 0, marginTop: "2px" }}>
                                •
                              </div>
                              <div style={{ flex: 1 }}>
                                {error}
                                {record.status === 'duplicate' && (
                                  <div style={{ 
                                    fontSize: theme.font.size.xs, 
                                    color: "#666", 
                                    marginTop: "2px",
                                    paddingLeft: theme.spacing.sm,
                                    fontStyle: "italic"
                                  }}>
                                    This record already exists in the system
                                  </div>
                                )}
                                {record.status === 'validation_failed' && (
                                  <div style={{ 
                                    fontSize: theme.font.size.xs, 
                                    color: "#666", 
                                    marginTop: "2px",
                                    paddingLeft: theme.spacing.sm,
                                    fontStyle: "italic"
                                  }}>
                                    Please check the data format and try again
                                  </div>
                                )}
                                {record.status === 'reference_not_found' && (
                                  <div style={{ 
                                    fontSize: theme.font.size.xs, 
                                    color: "#666", 
                                    marginTop: "2px",
                                    paddingLeft: theme.spacing.sm,
                                    fontStyle: "italic"
                                  }}>
                                    Referenced data (district, municipality, park, etc.) not found
                                  </div>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                      
                      {record.status === 'duplicate' && (
                        <div style={{ 
                          marginTop: theme.spacing.sm,
                          padding: theme.spacing.sm,
                          backgroundColor: "#fff3e0",
                          borderRadius: theme.radius.sm,
                          border: "1px solid #ffb74d",
                        }}>
                          <div style={{ fontSize: theme.font.size.sm, fontWeight: "600", color: "#e65100", display: "flex", alignItems: "center", gap: "4px" }}>
                            <FiInfo /> Suggested Action
                          </div>
                          <div style={{ fontSize: theme.font.size.sm, color: "#666", marginTop: "4px" }}>
                            This phone number already exists. If this is a new user, please use a different phone number or update the existing record.
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div style={{ 
                textAlign: "center", 
                padding: theme.spacing.xl, 
                color: "#999",
                backgroundColor: "#f9f9f9",
                borderRadius: theme.radius.md,
                border: "1px dashed #ddd"
              }}>
                <FiCheck size={48} style={{ marginBottom: theme.spacing.md, color: "#4caf50" }} />
                <div style={{ fontSize: theme.font.size.lg, marginBottom: theme.spacing.sm, color: "#4caf50" }}>
                  No Skipped Records!
                </div>
                <div style={{ fontSize: theme.font.size.sm }}>
                  All records were successfully processed and inserted
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Modal Footer */}
      <div
        style={{
          padding: theme.spacing.md,
          borderTop: "1px solid #eee",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#f8f9fa",
          flexWrap: "wrap",
          gap: theme.spacing.sm,
        }}
      >
        <div style={{ fontSize: theme.font.size.sm, color: "#666" }}>
          <strong>Summary:</strong> {summary.inserted_records} inserted, {summary.skipped_records} skipped
          {meta?.status && (
            <span style={{ color: "#4caf50", marginLeft: theme.spacing.sm }}>
              ✓ {meta.message}
            </span>
          )}
        </div>
        <div style={{ display: "flex", gap: theme.spacing.sm }}>
          <button
            onClick={() => {
              if (activeTab === "inserted" && summary.inserted_records > 0) {
                downloadSuccessReport('excel');
              } else if (activeTab === "skipped" && summary.skipped_records > 0) {
                downloadFailureReport('excel');
              } else {
                downloadFullReport('excel');
              }
            }}
            style={{
              padding: `${theme.spacing.sm} ${theme.spacing.md}`,
              backgroundColor: activeTab === "inserted" ? "#4caf50" : activeTab === "skipped" ? "#f44336" : theme.colors.primary,
              color: "white",
              border: "none",
              borderRadius: theme.radius.md,
              cursor: "pointer",
              fontWeight: "600",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              fontSize: theme.font.size.sm,
            }}
          >
            <FiDownload /> Download {activeTab === "inserted" ? "Success" : activeTab === "skipped" ? "Failed" : "Full"} Report
          </button>
          <button
            onClick={() => setShowDetailsModal(false)}
            style={{
              padding: `${theme.spacing.sm} ${theme.spacing.md}`,
              backgroundColor: "transparent",
              color: theme.colors.primary,
              border: `1px solid ${theme.colors.primary}`,
              borderRadius: theme.radius.md,
              cursor: "pointer",
              fontWeight: "600",
              fontSize: theme.font.size.sm,
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
)}
          </div>
        </div>
      )}
    </div>
  );
};

export default UserParkUserAddBulk;